import React from 'react';
import propTypes from 'prop-types';
import * as trafficRulesAction from '../../../store/actions/trafficRules';

import './index.css';

import {connect} from 'react-redux';
import {show as showActionSheet} from '../../../native/ActionSheet';
import * as navigator from '../../../native/navigator';
import { sendStatsEvent } from '../../../components/statistics/index';

class TrafficRegulations extends React.Component {
  static propTypes = {
    trip_id: propTypes.string.isRequired,
    trafficRules: propTypes.array,
    getTripTrafficRules: propTypes.func.isRequired
  };

  render() {
    if (!this.props.trafficRules.length) {
      return null;
    }

    return (
      <section className='traffic-regulations' onClick={this.handleClick}>
        <div className='section-title'>
          <h2>交规指南</h2>
        </div>
        <div className='content'>
          <p>当地交规、加油、停车实用信息</p>
        </div>
      </section>
    );
  }

  componentDidMount() {
    let {trip_id, getTripTrafficRules} = this.props;

    getTripTrafficRules(trip_id);
  }

  handleClick = () => {
    sendStatsEvent('trip_TrafficGuide_click');
    let {trafficRules} = this.props;

    if (trafficRules.length === 1) {
      return navigator.push(trafficRules[0].article_url);
    }

    let options = trafficRules.map(function (item) {
      return item.region_name;
    });

    options.push('取消');

    showActionSheet({
      title: '交规指南',
      options: options,
      callback: function (index) {
        let item = trafficRules[index];

        if (item) {
          navigator.push(item.article_url);
        }
      }
    });
  };
}

export default connect(function (state, ownProps) {
  return {
    ...ownProps,
    trafficRules: state.trafficRules.tripTrafficRules.data
  };
}, trafficRulesAction)(TrafficRegulations);



// WEBPACK FOOTER //
// ./src/pages/trip/TrafficRegulations/index.js